import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M17.0775 17.099C17.541 16.6257 18.1126 16.2 18.7751 16.2C19.8288 16.2 20.6213 17.1883 20.0777 18.0909C19.028 19.8341 17.1172 21 14.9341 21C11.6204 21 8.93408 18.3137 8.93408 15C8.93408 11.6863 11.6204 9 14.9341 9C17.1172 9 19.028 10.1659 20.0777 11.9091C20.6213 12.8117 19.8288 13.8 18.7751 13.8C18.1126 13.8 17.541 13.3743 17.0775 12.901C16.533 12.345 15.7738 12 14.9341 12C13.2772 12 11.9341 13.3431 11.9341 15C11.9341 16.6569 13.2772 18 14.9341 18C15.7738 18 16.533 17.655 17.0775 17.099Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM27 15C27 21.6274 21.6274 27 15 27C8.37258 27 3 21.6274 3 15C3 8.37258 8.37258 3 15 3C21.6274 3 27 8.37258 27 15Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}